import $ from 'jquery';

// Prevent the click event to bubble to the [data-toggle=collapse] to prevent the collapsing or expanding of the
// collapsible panel when checking or unchecking the checkbox or radio button.
$(document).on('click', '[data-toggle=collapse] .custom-checkbox, [data-toggle=collapse] .custom-radio, [data-toggle=collapse] :input[type=checkbox], [data-toggle=collapse] :input[type=radio]', function (e) {
    e.stopPropagation();
});

$(document).on('show.bs.collapse', function (e) {
    let targetPanel = $(e.target), // The panel to open
        accordion = $(targetPanel.attr('data-parent')), // The entire accordion
        scrollHeightDifference = ($('.navigation.sticky-top').outerHeight() || 0) * 1; // The height of other animated panels we need to take into account when scrolling

    if ($('[data-toggle="collapse"][data-target="#' + targetPanel.attr('id') + '"], [data-toggle="collapse"][href="#' + targetPanel.attr('id') + '"]').closest('.navigation').length) {
        // Do not scroll to collapsible panels when they are part of the navigation
        return;
    } else if (accordion.attr('data-collapse-disable-auto-scroll')) {
        return;
    }

    // If the panel is right after the button, choose the button as the scrollTarget, otherwise the panel itself
    let scrollTarget = targetPanel.prev().is('[data-toggle="collapse"]') && targetPanel.prev().is('[data-target="#' + targetPanel.attr('id') + '"], [href="#' + targetPanel.attr('id') + '"]')  ? targetPanel.prev() : targetPanel;

    if (accordion.length) {
        // If it's an accordion, then there are other elements that may have been opened and that are collapsed
        // automatically when opening another element in that accordion.
        // This means that we need to take the heights of the other opened panels into account as well when we
        // scroll to the right location in the page.
        let openedPanels = $('.collapsing[data-parent="' + targetPanel.attr('data-parent') + '"], .collapse.show[data-parent="' + targetPanel.attr('data-parent') + '"]');
        let targetPanelOffsetTop = targetPanel.prev(':visible').length ? targetPanel.prev(':visible').offset().top + targetPanel.prev(':visible').outerHeight() : 0; // targetPanel is not visible yet

        openedPanels.each(function () {
            if ($(this).offset().top < targetPanelOffsetTop) {
                // If the target panel is after the already opened panels, then we need to take the height of the
                // already opened panel into account.
                scrollHeightDifference += $(this).outerHeight();
            }
        });

        $('html, body').animate({
            scrollTop: scrollTarget.offset().top - scrollHeightDifference
        }, 200);
    } else if (scrollTarget.length) {
        // Scroll the page to the scrollTarget
        targetPanel.one('shown.bs.collapse', function (e) {
            $('html, body').animate({
                scrollTop: scrollTarget.offset().top
            }, 100);
        });
    }
});

// Add a DOM ready event listener to open a collapsible panel automatically based on the hash in the url
$(function () {
    let hash = (window.location.hash).toString().replace(/^#/, '');
    if (hash && $('#' + hash).length) {
        let panel = $('#' + hash).closest('.collapse');
        if (!panel.length) {
            return;
        }

        $('[data-toggle=collapse][data-target="' + panel.attr('id') + '"]').removeClass('collapsed');
        panel.addClass('show');
    }
});

export default {};